module.exports = __webpack_public_path__ + "jtails-build/img/member_header_icon.a29c2aa3.svg";